import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./AuthPage.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility

  const auth = getAuth();
  const navigate = useNavigate();

  // Handle Email + Password Login
  const handleLoginWithPassword = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      setMessage(`Login successful! Welcome, ${userCredential.user.email}`);
      navigate("/"); // Redirect to homepage
    } catch (error) {
      console.error("Error logging in with email and password:", error.message);
      setMessage("Failed to log in. Please check your credentials and try again.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Log in</h2>
        <input
          type="email"
          placeholder="Enter Your Email..."
          className="auth-input"
          list="email-suggestions"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <datalist id="email-suggestions">
        </datalist>

        {/* Password input */}
        <div className="password-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password..."
            className="auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <img
            src={showPassword ? "/eye-open-icon.png" : "/eye-closed-icon.png"}
            alt="Toggle Visibility"
            className="toggle-password-icon"
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>

        {/* Log In button */}
        <button className="auth-button" onClick={handleLoginWithPassword}>
          Log In
        </button>

        {message && <p className="auth-message">{message}</p>}
      </div>
      <img src="/auth-image-16.png" alt="Auth Illustration" className="auth-image" />
      <div className="auth-dots">
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
};

export default Login;
